import { render, staticRenderFns } from "./DeleteRecordModal.vue?vue&type=template&id=3ffa6314&"
import script from "./DeleteRecordModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteRecordModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports